import React from 'react';
import '../styles/AboutPage.css';

const AboutPage = () => {
    return (
        <div className="about-page">
            <div className="about-container">
                {/* Profile Section with Image and Bio */}
                <section className="profile-section">
                    <div className="profile-content">
                        <div className="profile-image">
                            <img
                                src={process.env.PUBLIC_URL + "/images/profile_pic.jpg"}
                                alt="Emanuele Nevali"
                                onError={(e) => {
                                    console.error("Profile image not found, using fallback");
                                    e.target.style.display = 'none';
                                    const fallback = e.target.parentNode.querySelector('.profile-fallback');
                                    if (fallback) {
                                        fallback.style.display = 'flex';
                                    }
                                }}
                            />
                            <div className="profile-fallback" style={{ display: 'none' }}>
                                <span className="profile-icon">👨‍💻</span>
                            </div>
                        </div>

                        <div className="profile-info">
                            <h1>Emanuele Nevali</h1>
                            <p className="profile-title">AI Researcher & Engineer</p>

                            <div className="bio">
                                <p>
                                    Hi! I'm Emanuele, a passionate AI researcher and engineer with a focus on
                                    machine learning, natural language processing, and computer vision. Currently pursuing
                                    my Master's at EPFL, I've had the privilege of working with cutting-edge teams at
                                    Google DeepMind and Google Research, contributing to groundbreaking multimodal AI systems.
                                </p>
                                <p>
                                    My research spans from evolutionary discovery and interpretability in large language models to
                                    multimodalility, alignment, reinforcement learning and imitation learning.
                                </p>
                                <p>
                                    When I'm not diving deep into research or coding, I enjoy exploring new technologies,
                                    mentoring students, and contributing to open-source projects that advance the field of AI.
                                </p>
                            </div>

                            <div className="contact-info">
                                <span>✉️ manu4375@gmail.com</span>
                                <span>💼 <a href="https://ch.linkedin.com/in/emanuele-nevali-090820245" target="_blank" rel="noopener noreferrer">LinkedIn</a></span>
                                <span>🔗 <a href="https://github.com/emanuelenevali" target="_blank" rel="noopener noreferrer">GitHub</a></span>
                                <span>🎓 <a href="https://scholar.google.com/citations?user=m2UA7P0AAAAJ" target="_blank" rel="noopener noreferrer">Google Scholar</a></span>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Announcements Section */}
                <section className="announcements-section">
                    <h2>📢 Recent Updates & Announcements</h2>
                    <div className="announcements-grid">
                        <div className="announcement-card">
                            <div className="announcement-date">October 2025</div>
                            <h3>New Paper Submitted to AISTAT 2026!</h3>
                            <p>
                                Our work on "Rate optimal learning of equilibria from data" has been submitted to AISTAT 2026! 
                                We present the first interactive Multi-Agent Imitation Learning algorithm with near-optimal 
                                sample complexity, improving from O(ε⁻⁸) to O(ε⁻²).
                            </p>
                        </div>

                        <div className="announcement-card">
                            <div className="announcement-date">September 2025</div>
                            <h3>Starting Thesis soon...</h3>
                            <p>
                                Excited to share that I will soon be starting my Master's thesis on Imitation Learning at <a href="https://www.epfl.ch/labs/lions/" target="_blank" rel="noopener noreferrer">LIONS</a>
                            </p>
                        </div>

                        <div className="announcement-card">
                            <div className="announcement-date">July 2025</div>
                            <h3>Google Paper has been accepted!</h3>
                            <p>
                                Our work on sketch-to-layout generation has been accepted at ICCV workshop 2025!
                            </p>
                        </div>

                        <div className="announcement-card">
                            <div className="announcement-date">January 2025</div>
                            <h3>AI Tutor for STEM Education Released</h3>
                            <p>
                                Our specialized AI tutor project is now available on HuggingFace! This system enhances
                                a 0.6B parameter model through MCQA fine-tuning, DPO, and RAG techniques specifically
                                for STEM education.
                            </p>
                        </div>

                        <div className="announcement-card">
                            <div className="announcement-date">August 2024</div>
                            <h3>Successful Internship at Google DeepMind</h3>
                            <p>
                                Completed an amazing internship with the Viva and Digital Ink teams, contributing
                                to multimodal AI capabilities and achieving 3x improvements in layout generation metrics.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Next Steps Section */}
                <section className="next-steps-section">
                    <h2>🚀 What's Next</h2>
                    <div className="roadmap-item">
                                <div className="roadmap-timeline">Fall 2025</div>
                                <div className="roadmap-content">
                                    <h3>Master's Thesis Completion</h3>
                                    <p>
                                        I will be soon finalizing my Master's thesis, I am currently activily looking for opportunities in industry for February/March 2026! Feel free to reach out if you have any opportunities or suggestions!
                                    </p>
                                </div>
                            </div>
                    <div className="next-steps-content">
                        <div className="roadmap">
                            <div className="roadmap-item">
                                <div className="roadmap-timeline">Summer 2025</div>
                                <div className="roadmap-content">
                                    <h3>Evolutionary search at <a href="https://www.epfl.ch/labs/claire/" target="_blank" rel="noopener noreferrer">CLAIRE</a></h3>
                                    <p>
                                        Working with Google DeepMind's FunSearch on evolutionary search.
                                    </p>
                                </div>
                            </div>

                            <div className="roadmap-item">
                                <div className="roadmap-timeline">Summer 2025</div>
                                <div className="roadmap-content">
                                    <h3>Master's Thesis Completion</h3>
                                    <p>
                                        Finalizing Diffusion Transformers paper before submission
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="interests">
                            <h3>Current Research Interests</h3>
                            <div className="interests-tags">
                                <span className="tag">Multimodal AI</span>
                                <span className="tag">Mechanistic Interpretability</span>
                                <span className="tag">Evolutionary Search</span>
                                <span className="tag">AI Safety & Alignment</span>
                                <span className="tag">Reinforcement Learning</span>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </div>
    );
};

export default AboutPage;